module.exports = __webpack_public_path__ + "ab17cd0b146a20585f0c5ee2be946417.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarChloe1.png
// module id = 144
// module chunks = 0